import { isValidEthereumAddress, padHexNumber } from './web3.helpers';

export const separateAddress = (address: string, number = 3): string => (
  address ? `0x${address.substring(2, 2 + number)}...${address.substring(address.length - number)}` : address
);

export const formatAddress = (address: string, number = 4, endTrim = 6): string => (address ? (
  `${address.substring(0, number)}...${address.substring(address.length - endTrim)}`
) : address);

export const castAddress = (address: string): string => {
  if (isValidEthereumAddress(address)) {
    return address;
  }

  try {
    return padHexNumber(BigInt(address).toString(16), 40, false, true);
  } catch {
    return address;
  }
};
